@for (child of links(); track $index) {
    @if (!$first) {
        <span>,&nbsp;</span>
    }

    <a [routerLink]="child.routerLink"
       [queryParams]="child.queryParams"
       [queryParamsHandling]="child.queryParamsHandling">{{ child.title }}</a>
}
